import { render } from "./LichensTableView.vue?vue&type=template&id=84680f44"
import script from "./LichensTableView.vue?vue&type=script&lang=js"
export * from "./LichensTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__